var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class BenQInteractiveFlatPanel {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.deviceId = '01';
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: `8${this.deviceId}gl000`,
                next: /\d+rl\d+/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`\x44${this.deviceId}g\x20\x0400000000000000`, /\x44\d{2}r\x20\x04([\d\.]+)0000000000|\d{3}-/i, tags);
                return match[1] ? match[1] : 'unknown';
            }),
            powerOffRestrictions: ['get'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`8${this.deviceId}gl000`, /\d+rl(\d+)/i, tags);
                return match[1] === '001';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`8${this.deviceId}s!${power ? '001' : '000'}`, /^\d{3}(\+|-)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 6000);
                this.framework.suspend(power ? 6000 : 2000);
                return match[1] === '+' ? power : this.state.power.value;
            }),
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`8${this.deviceId}gj000`, /\d+rj(\d+)/i, tags);
                return parseInt(match[1], 10).toString(); // remove leading zeros
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`8${this.deviceId}s"${code.padStart(3, '0')}`, /^\d{3}(\+|-)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return match[1] === '+' ? code : this.state.videoInput.value;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`8${this.deviceId}gf000`, /\d+rf(\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`8${this.deviceId}s5${volume.toString().padStart(3, '0')}`, /^\d{3}(\+|-)/i, tags);
                return match[1] === '+' ? volume : this.state.volume.value;
            }),
            range: { max: 100, min: 0, round: 1 },
            powerOffRestrictions: ['get', 'set'],
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`8${this.deviceId}gg000`, /\d+rg(\d+)/i, tags);
                return match[1] === '001';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`8${this.deviceId}s6${mute ? '001' : '000'}`, /^\d{3}(\+|-)/i, tags);
                return match[1] === '+' ? mute : this.state.volumeMute.value;
            }),
        };
        // polling
        this.polls = [
            { intervalMs: 3000, controls: ['power', 'videoInput'] },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
BenQInteractiveFlatPanel.driverType = 'socketDriver';
BenQInteractiveFlatPanel.key = '-MOYDKsyKZxWZ7JrJum6';
BenQInteractiveFlatPanel.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r'],
    },
    sendTerminator: '\r',
    isBinary: true,
};
BenQInteractiveFlatPanel.socketOptions = [
    Object.assign(Object.assign({}, BenQInteractiveFlatPanel.baseSocketOptions), { port: 4660 }),
    Object.assign(Object.assign({}, BenQInteractiveFlatPanel.baseSocketOptions), { port: 4999 }),
];
